import { render, staticRenderFns } from "./trans-type-select.vue?vue&type=template&id=14bed646&"
import script from "./trans-type-select.vue?vue&type=script&lang=js&"
export * from "./trans-type-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports